import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import addenvironment from "./components/addenvironment.vue";
export default {
  name: "indexInterview",
  mixins: [loadMoreList],
  components: {
    addenvironment: addenvironment
  },
  data: function data() {
    return {
      pagingReqFn: "environments",
      pagingReqValue: "",
      paramsData: {
        name: ''
      }
    };
  },
  mounted: function mounted() {},
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'environmentsDelete',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};